// Wallet Service Interface - Defines contract for wallet operations

/**
 * Interface for wallet service implementations
 * Enables dependency injection and testing with mock implementations
 */
export class IWalletService {
  /**
   * Connect to a wallet - auto-detects available Solana wallet
   * @returns {Promise<{success: boolean, address: string, publicKey: any}>}
   */
  async connect() {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Disconnect from current wallet
   * @returns {Promise<{success: boolean}>}
   */
  async disconnect() {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Check if wallet is connected
   * @returns {boolean}
   */
  isConnected() {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Get current wallet address
   * @returns {string|null}
   */
  getAddress() {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Get current wallet public key
   * @returns {any|null}
   */
  getPublicKey() {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Sign a transaction
   * @param {any} transaction - Transaction to sign
   * @returns {Promise<any>}
   */
  async signTransaction(transaction) {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Sign multiple transactions
   * @param {any[]} transactions - Transactions to sign
   * @returns {Promise<any[]>}
   */
  async signAllTransactions(transactions) {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Get supported wallet types
   * @returns {string[]}
   */
  getSupportedWallets() {
    throw new Error('Method must be implemented by concrete class');
  }

  /**
   * Check if a specific wallet type is available
   * @param {string} walletType - Wallet type to check
   * @returns {boolean}
   */
  isWalletAvailable(walletType) {
    throw new Error('Method must be implemented by concrete class');
  }
}
